import useIntl from '../../../hooks/useIntl';
import messages from './messages';
import { STEP_FIELDS } from './constants';

export const useFieldRules = () => {
  const intl = useIntl();

  return {
    budgetName: { required: true },
    budgetType: { required: true },
    budgetPeriod: { required: true },
    currentBudgetYear: { required: true },
    actualBudgetFrom: {
      required: true,
      validate: (value, form) => {
        if (!value || !form.actualBudgetTo) return;

        return value.isBefore(form.actualBudgetTo)
          ? true
          : intl.formatMessage(messages.datePickerActualBudgetFromError);
      },
    },
    actualBudgetTo: {
      required: true,
      validate: (value, form) => {
        if (!value || !form.actualBudgetFrom) return;

        return value.isAfter(form.actualBudgetFrom)
          ? true
          : intl.formatMessage(messages.datePickerActualBudgetToError);
      },
    },
    proposedBudgetFill: { required: true },
    intacctYTDActuals: { required: true },
    commentsFill: { required: true },
  };
};

export const useDropdownOptions = (rentForecast) => {
  const intl = useIntl();
  const currentYear = rentForecast
    ? Number.parseInt(rentForecast.year, 10) // This shouldn't have to be parsed, but it's stored as string
    : new Date().getFullYear();

  return {
    currentBudgetOptions: [
      {
        text: String(currentYear),
        value: String(currentYear),
      },
      {
        // next year
        text: String(currentYear + 1),
        value: String(currentYear + 1),
      },
    ],
    budgetPeriodOptions: [
      {
        text: intl.formatMessage(messages.dropdownBudgetPeriodAnnualOption),
        value: 'ANNUAL',
      },
      {
        text: intl.formatMessage(messages.dropdownBudgetPeriodQuarterlyOption),
        value: 'QUARTERLY',
      },
      {
        text: intl.formatMessage(messages.dropdownBudgetPeriodMonthlyOption),
        value: 'MONTHLY',
      },
    ],
    budgetTypeOptions: [
      {
        text: intl.formatMessage(messages.dropdownBudgetTypeInitialOption),
        value: 'INITIAL',
      },
      {
        text: intl.formatMessage(
          messages.dropdownBudgetTypeRegularReportOption,
        ),
        value: 'REGULAR_REPORT',
      },
      {
        value: 'RENT_CHANGE',
        text: intl.formatMessage(messages.dropdownBudgetTypeRentChangeOption),
      },
      {
        text: intl.formatMessage(messages.dropdownBudgetTypeSMROption),
        value: 'SMR',
      },
      {
        text: intl.formatMessage(
          messages.dropdownBudgetTypeOtherServicingOption,
        ),
        value: 'OTHER_SERVICING',
      },
    ],
    commentsOptions: [
      {
        text: intl.formatMessage(messages.dropdownCommentsProposedOption),
        value: 'PROPOSED_BUDGET_COMMENTS',
      },
      {
        text: intl.formatMessage(messages.dropdownCommentsNothingOption),
        value: 'NOTHING',
      },
    ],
  };
};

export async function validateForm(ReactHookFormProps, step) {
  return ReactHookFormProps.trigger(STEP_FIELDS[step]);
}
